import React, { useEffect, useRef, useState } from "react"

import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import { faPlus } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { toast } from "react-toastify"

import { apiRoute, ENUM_CURRENCY_SETTING_VAL, ENUM_MOD_NAME, ENUM_MOD_PARAMETER, ENUM_USERSETING_PARAMS, ENUM_USERSETING_SETVALUE, GetLoginCredentialDb, getModValue, linksUrl } from "../constants/enum.js"
import {
  ErrorCard,
  LoadingCard,
  MainContainer,
  NextUITable,

} from "../components/index.js"
import { useFetchWithBody, usePost, usePostLogin } from "../api/reactQueryCustomHooks.jsx"
import { resetCompCode, setAppType, setCompCode, setCompInfo, setCurrencyFormat, setCurrencyFormatBy, setCurrencyType, setReload } from "../state/companySlice.jsx"
import { COLUMN_ALIGN_TYPE, TOP_ACTION_BTN_TYPE } from "../components/NextUITable.jsx"
import { addToast, Button } from "@heroui/react"
import { setLogout } from "../state/authSlice.jsx"
import { useQueryClient } from "@tanstack/react-query"

const Companies = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { yearId, compCode } = useSelector((state) => state.company)
  const { user } = useSelector((state) => state.auth)
  const queryClient = useQueryClient()
  const [compData, setCompData] = useState([])

  const {
    isPending,
    isError,
    data = [],
    mutate: funSetYearId
  } = usePost({
    url: apiRoute.setAcYearId,
    queryKey: "MainCompanyFetching",
    onSuccessTasks: (data) => {
      if (userCompMapData && userCompMapData.length > 0) {
        const selComp = userCompMapData.map(ele => String(ele.COMPCODE));
        const selCompData = data.filter((ele) => selComp.includes(String(ele.COMPCODE)))
        setCompData(selCompData)
      }
      else
        setCompData(data)
    }
  })

  const { isError: isErrorModSet, data: modSetting = [] } = useFetchWithBody({
    url: apiRoute.modSetting.getModSetting,
    queryKey: "fetchModSettingCurrency",
    inputData: {
      mod_name: ENUM_MOD_NAME.GeneralSettings
    }
  })

  const { data: userCompMapData = [], } = useFetchWithBody({
    url: apiRoute.userCompMaping.getUserMaping,
    queryKey: "getUsermaping",
    inputData: {
      userid: user.userid
    },
  })
  useEffect(() => {
    let CurrencyType = getModValue(ENUM_MOD_PARAMETER.GeneralSetting.CurrencyType, modSetting)
    let CurrencyFormatBy = getModValue(ENUM_MOD_PARAMETER.GeneralSetting.CurrencyFormatBy, modSetting)

    dispatch(setCurrencyType(CurrencyType ?? ""))
    dispatch(setCurrencyFormatBy(CurrencyFormatBy ?? ""))
  }, [modSetting])

  useEffect(() => {
    funSetYearId({
      data: {
        ac_year: yearId,
        comp_code: ''
      }
    })

  }, [])



  const INITIAL_VISIBLE_COLUMNS = ["COMPNAME"]

  const columns = [{ name: "COMPNAME", uid: "COMPNAME", sortable: true, align: COLUMN_ALIGN_TYPE.left }]

  const topActionBtn = [
    {
      label: "Connect",
      icon: <FontAwesomeIcon icon={faPlus} />,
      isShowOnSelection: true,
      type: TOP_ACTION_BTN_TYPE.link,
      onClick: ({ selectedKeys }) => {
        let selectedCompCode = []
        let selectedCompName = []
        let selectedCompLogo = []
        if (selectedKeys !== "all") {
          selectedKeys.forEach((value) => {
            selectedCompCode.push(value)
            //get selected compname
            let filterData = compData.filter((ele) => ele.COMPCODE == value)
            if (filterData && filterData.length > 0) {
              selectedCompName.push(filterData[0].COMPNAME)
              selectedCompLogo.push(filterData[0].COMPLOGO)
            }
          })
        } else {
          compData.map((item) => selectedCompCode.push(item.COMPCODE))
        }
        toast.success("Conntected", {
          position: "top-center",
          autoClose: 1000,
        })

        //get selected company name 
        const intSelCompCode = selectedCompCode.map(value => parseInt(value, 10));
        const selData = compData.filter((ele) => intSelCompCode.includes(ele.COMPCODE))
        
        dispatch(setCompCode({ compCode: selectedCompCode, compName: selectedCompName,compLogo:selectedCompLogo }))
        dispatch(setCompInfo({
          yearId: selData[0]?.YEAR_ID, startDate: selData[0]?.SDATE, endDate: selData[0]?.EDATE,
          state: selData[0]?.STATE, groupCode: selData[0].CGCODE
          , address: selData[0]?.COMP_ADDRESS
          , panNo: selData[0]?.IT_NO
          , objComp: selData
          , gstNo: selData[0]?.Gst_No
          //,objYear:[]]
        }))

        let startup_page = linksUrl.dashboard.tradingDashboard

        navigate(startup_page)
      },
    },
  ]

  if (isPending) {
    return <LoadingCard />
  }
  const handleOnclick = () => {
    dispatch(setLogout())
    dispatch(resetCompCode())
    queryClient.removeQueries()
    navigate(linksUrl.login)
  }
  // if (isError) {
  //   return <ErrorCard />
  // }

  return (
    <div>
      <MainContainer pageName="Company" info={[]} breadcrumbs={["Home", "Company"]}>
        {/* <MyComponent items={items}  /> */}


        {isError ? <div className="bg-yellow-200 px-6 py-4 my-4 text-amber-700 rounded-md text-md flex gap-4  items-center mx-auto max-w-lg">Something went wrong !
          <Button onPress={handleOnclick()} variant="light" style={{ color: "#eb8b0e" }} className="text-sm text-Rose-700" >Click here to Reconnect</Button> </div> :
          <NextUITable
            INITIAL_VISIBLE_COLUMNS={INITIAL_VISIBLE_COLUMNS}
            data={compData}
            columns={columns}
            exportColumns={columns}
            topActionBtn={topActionBtn}
            downloadFileName="Company"
            showAdvanceFilter={false}
            id="COMPCODE"
            rowSelection={true}

          />
        }
      </MainContainer>

    </div>
  )
}

export default Companies
